import ScenarioDisplayProps from "./ScenarioDisplayProps";

// Should we have tax options be separate (like long-term and short-term?)
export const defaultNoScenarioDisplayProps: ScenarioDisplayProps = {
  plotTitle: "",
  plotSubtitle: "",
  plotExtraInfo: "",
  plotJson: {
    data: [],
    layout: { title: "Forecast Loading" },
    config: {},
  },
  totalValue: -1,
  coreStockValue: -1,
  otherStockValue: -1,
  cashValue: -1,
  sharpeRatio: -1,
  taxSavings: -1,
  maxPortfolioValue: -1,
  maxStockPrice: -1,
  referenceDateString: "",
  futureReferenceDateString: "",
  symbol: "",
  otherSymbol: "",
  updated: false,
};
